import React from "react";
import DatePicker from "react-datepicker";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
//import "react-date-range/dist/styles.css"; // Main style file
//import "react-date-range/dist/theme/default.css"; // Theme CSS file
import "react-datepicker/dist/react-datepicker.css";
import { enGB } from "date-fns/esm/locale";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export const unableToAttend="Unable to attend";

export const fixupCeremonyUnableToAttend = (value) => {
  if (!Array.isArray(value)) return [];
  if (value.length < 1) return [unableToAttend];
  return value;
}

const AddGuestForm = ({ 
  selectedCeremoniesForRsvp, 
  gogAnswers, 
  userQuestions, 
  onDelete, 
  onChange, 
  onCeremonyChange, 
  mainFormData, 
}) => {
  const formData = gogAnswers.formData || {};

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onChange(name, value);
  };

  const handleCeremonyChange = (event) => {
    const { name, value } = event.target;
    onCeremonyChange(name, value);
  }

  const dateFor = function(qid) {
    const v=formData[`question${qid}`];
    if (!v) return null;
    const d=new Date(v);
    if (isNaN(d)) return null;
    return d;
  }

  const dateDeArray = function(qid, idx) {
    const v=formData[`question${qid}`];
    if (!Array.isArray(v)) return null;
    var d=new Date(v[idx]);
    if (isNaN(d)) return null;
    return d;
  }

  const asArray = (a) => {
    if (Array.isArray(a)) return a;
    if (a===undefined || a===null) return [];
    return [a];
  }

  const isQuestionNumber=(num, val) => {
    for (const question of userQuestions) {
      if (question.question_number===num) {
        return String(formData[`question${question.id}`]).toLowerCase()===val;
      }
    }
    return false;
  }

  const showQuestion = (question) => { // NOTE: DUPLICATED: IN AddGuestForm AND NewRsvpForm
    if (question.question_number===13 || question.question_number===14) {
      return isQuestionNumber(12, "yes"); // mehndi
    }
    if (question.question_number===23 || question.question_number===24) {
      return isQuestionNumber(22, "yes"); // venue
    }
    if (question.question_number===26) {
      return isQuestionNumber(22, "no"); // venue
    }
    if (question.question_number===28) {
      return isQuestionNumber(27, "yes"); // extend stay
    }
    // Just for guests of guest:
    if (question.question_number===3) {
      return false; // email
    }
    if (question.question_number===4) {
      return false; // mobile
    }
    return true
  }

  const handleAsAbove = (question) => {
    const key=`question${question.id}`;
    onChange(key, mainFormData[key]);
  }

  const showAsAbove = (question) => {
    switch (question.question_number) {
      case 1: // full name
      case 6: // WHAT EVENTS WILL YOU BE ATTENDING 
      case 9: // Assistance
      case 30: // Song
        return false;
    }
    return true;
/*
    switch (question.question_number) {
      case 5: // GUEST OF
      case 7: // DIETARY REQUIREMENTS
      case 12: // WILL YOU PARTICIPATE IN MEHNDI?
      case 13: // HOW MANY HANDS WOULD YOU LIKE MEHNDI ON?
      case 14: // WHERE WOULD YOU LIKE YOUR MEHNDI?
      case 19: // FLIGHT ARRIVAL
      case 20: // FLIGHT DEPARTURE
      case 21: // WILL YOU REQUIRE TRANSFERS?
      case 22: // WILL YOU BE STAYING AT THE COUPLES EVENT VENUE / RECOMMENDED HOTEL?
      case 23: // IF YES, HOW MANY ROOMS WILL YOU AND YOUR FAMILY REQUIRE?
      case 26: // IF NO, WHAT HOTEL WILL YOU BE STAYING AT?
      case 27: // WOULD YOU LIKE TO EXTEND YOUR STAY AT THE COUPLES EVENT VENUE HOTEL?
      case 29: // WOULD YOU LIKE TO TAKE PART IN ANY EXCURSIONS?
      case 31: // FLIGHT ARRIVAL NUMBER
        return true;
    }
    return false;
*/
  }

  return (
    <div>
        <div className="container card-b-1 px-2 px-md-4">
          <h4 style={{float:"none"}}>Guest Details</h4>
          <form className="row card-rsvp new-rsvp">
            {userQuestions
              ?.map((question, index) => (
                showQuestion(question) && <div
                  className="col-sm-12 col-md-4 col-lg-4 rsvp-padding rsvp-form"
                  key={index}
                >
                  <div className="question">
                    <label htmlFor={`question${index + 1}`}>
                      {question.questions}
                    </label>

                    <div className="form-rs">
                      <div className="crose"></div>
                      {question.question_type === "Free text" && (
                        <div className="questionText">
                          <input
                            type="text"
                            className="form-control"
                            name={`question${question.id}`}
                            value={formData[`question${question.id}`] || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      )}

                      {question.question_type === "Api" && (<>
                         (Please select the event(s) you can attend)
                        <div className="col-sm-12 col-md-4 col-lg-3 rsvp-padding">
                          <FormControl sx={{ m: 1, width: 300 }}>
                            <InputLabel id={`demo-select-label${index}`}>
                              {question.questions}
                            </InputLabel>

                            <Select
                              labelId={`demo-select-label${index}`}
                              name={`question${question.id}`}
                              multiple
                              value={fixupCeremonyUnableToAttend(formData[`question${question.id}`])}
                              onChange={handleCeremonyChange}
                              input={<OutlinedInput label="Tag" />}
                              renderValue={(selected) => selected.join(", ")}
                              MenuProps={MenuProps}
                            >
                              {selectedCeremoniesForRsvp?.map((value) => (
                                <MenuItem
                                  key={value}
                                  value={value}
                                  selected={formData[`question${question.id}`]?.indexOf(value)>=0}
                                >
                                  {value}
                                </MenuItem>
                              ))}
                              <MenuItem key={unableToAttend} value={unableToAttend}>
                                {unableToAttend}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </>)}

                      {question.question_type === "MultiDropTypeIn" && 
                      <div className="col-sm-12 col-md-4 col-lg-3 rsvp-padding">
                        <FormControl sx={{ m: 1, width: 300 }}>
                          <InputLabel id={`demo-select-label${index}`}>
                            {question.questions}
                          </InputLabel>
                          <Select
                            labelId={`demo-select-label${index}`}
                            id={`question${question.id}`}
                            name={`question${question.id}`}
                            multiple
                            value={asArray(formData[`question${question.id}`])}
                            onChange={handleInputChange}
                            input={<OutlinedInput label="Tag" />}
  //                          renderValue={(selected) => (selected.join) ? selected.join(", ") : selected}
                            MenuProps={MenuProps}
                          >
                            {question?.question_value?.map((value) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            id={`question${question.id}`}
                            name={`question${question.id}RadioText`}
                            placeholder={question.question_number===8 ? "Please specify any allergies not on our list" : ""}
                            value={formData[`question${question.id}RadioText`] || ""}
                            onChange={(e) => handleInputChange(e)}
                          />
                        </div>
                      </div>}

                      {question.question_type === "Dropdown" && (
                        <div className="col-sm-12 col-md-4 col-lg-3 rsvp-padding">
                          <FormControl sx={{ m: 1, width: 300 }}>
                            <InputLabel id={`demo-select-label${index}`}>
                              {question.questions}
                            </InputLabel>
                            {((question.question_number === 6 ||
                              question.question_number === 7) && (
                              <Select
                                labelId={`demo-select-label${index}`}
                                name={`question${question.id}`}
                                multiple
                                value={formData[`question${question.id}`] || []}
                                onChange={handleInputChange}
                                input={<OutlinedInput label="Tag" />}
                                renderValue={(selected) => selected.join(", ")}
                                MenuProps={MenuProps}
                              >
                                {question?.question_value?.map((value) => (
                                  <MenuItem key={value} value={value} selected={formData[`question${question.id}`]?.indexOf(value)>=0}>
                                    {value}
                                  </MenuItem>
                                ))}
                              </Select>
                            )) || (
                              <Select
                                labelId={`demo-simple-select-label${index}`}
                                name={`question${question.id}`}
                                value={formData[`question${question.id}`] || ""}
                                onChange={handleInputChange}
                                input={<OutlinedInput label="Tag" />}
                                MenuProps={MenuProps}
                              >
                                {question?.question_value?.map((value) => (
                                  <MenuItem key={value} value={value} selected={formData[`question${question.id}`]==0}>
                                    {value}
                                  </MenuItem>
                                ))}
                              </Select>
                            )}
                          </FormControl>
                        </div>
                      )}


                      {question.question_type === "Number" && (
                          <div className="question1">
                            <input
                              type="number"
                              className="form-control"
                              name={`question${question.id}`}
                              value={formData[`question${question.id}`] || 0}
                              onChange={handleInputChange}
                            />
                          </div>
                        )}

                      {question.question_type === "Radio text" && (
                        <div className="question1">
                          <input
                            type="radio"
                            name={`question${question.id}`}
                            value="yes"
                            onChange={handleInputChange}
                            checked={formData[`question${question.id}`] === "yes"}
                          />
                          <label
                            htmlFor={`question${question.id}`}
                          >
                            Yes
                          </label>
                          <input
                            type="radio"
                            name={`question${question.id}`}
                            value="no"
                            onChange={handleInputChange}
                            checked={formData[`question${question.id}`] === "no"}
                          />
                          <label
                            htmlFor={`question${question.id}`}
                          >
                            No
                          </label>
                        </div>
                      )}

                      {question.question_type === "Radio text" &&
                        formData[`question${question.id}`] === "yes" && ( // Conditionally render the text box
                          <div className="question1">
                            <input
                              type="text"
                              className="form-control"
                              value={formData[`question${question.id}RadioText`] || ""}
                              name={`question${question.id}RadioText`} // Append "RadioText" to the name
                              onChange={handleInputChange}
                            />
                          </div>
                        )}
                      {question.question_type === "Calendar" && (
                        <div className="question1">
                          <DatePicker
                            className="form-control"
                            name={`question${question.id}`}
                            selected={dateFor(question.id)}
                            locale={enGB}
                            showTimeSelect
                            timeIntervals={10}
                            timeFormat="p"
                            dateFormat="Pp"
                            onChange={(date) => {
                              handleInputChange({
                                target: {
                                  name: `question${question.id}`,
                                  value: date,
                                },
                              });
                            }}
                          />
                        </div>
                      )}

                      {question.question_type === "Date Range" && (
                        <div className="question1">
                          <DatePicker
                            className="form-control"
                            id={`question${question.id}`}
                            name={`question${question.id}`}
                            startDate={dateDeArray(question.id, 0)}
                            endDate={dateDeArray(question.id, 1)}
                            selectsRange
                            dateFormat="P"
                            locale={enGB}
                            onChange={(dates) => {
                              handleInputChange({
                                target: {
                                  name: `question${question.id}`,
                                  value: [
                                    (dates[0]) ? dates[0].toISOString() : undefined, 
                                    (dates[1]) ? dates[1].toISOString() : undefined
                                  ],
                                },
                              });
                            }}
                          />
                        </div>
                      )}

                    </div>
                    
                    {showAsAbove(question) && 
                      <button className="btn asAboveBtn" type="button"
                        onClick={() => handleAsAbove(question)}>
                          Same as head guest
                      </button>
                    }
                  </div>
                </div>
              ))}

            <div className="crl"></div>

            {!gogAnswers.isNamed && <div className="col-md-12">
              <button
                className="btn view-r-btn save-btn-1"
                type="button"
                onClick={onDelete}
              >
                Remove Guest
              </button>
            </div>}
          </form>
        </div>
    </div>
  );
};

export default AddGuestForm;
